import React from 'react'
import styled from 'styled-components'
import media from 'utils/media'
import FontAwesome from 'components/FontAwesome'
import LangSelector from './LangSelector'
import { StyledControlBtn, StyledThemeIcon } from './styles'
import { Link } from 'gatsby'
import Newsletter from './Newsletter'

export default function DesktopControls({ languages, path, handleDarkMode, newsletterText }) {
   return (
      <StyledWrapper>
         <ControlsGroup>
            <LangSelector languages={languages} path={path} />
            <StyledControlBtn onClick={handleDarkMode} aria-label="change theme">
               <StyledThemeIcon />
            </StyledControlBtn>
            <Link href={`/search`}>
               <StyledControlBtn aria-label="Open search">
                  <FontAwesome icon="search" />
               </StyledControlBtn>
            </Link>
         </ControlsGroup>
         <Newsletter text={newsletterText} />
      </StyledWrapper>
   )
}

const StyledWrapper = styled.div`
   display: flex;
   align-items: center;
   gap: 8px;
`

const ControlsGroup = styled.div`
   display: none;

   ${media.greaterThan('lg')`
      display: flex;
      align-items: center;
      gap: 8px;
   `};
`
